import styled from "styled-components";

import ValueInput from "./ValueInput";
import useSuspenseParameter from "../../../../../../clients/taxonomy/useParameter";
import * as UI from "../../../../../../modules/ui-kit";
import ParameterCardContainer from "../../entities/parameter/ParameterCardContainer";


const Styled = styled.div`
    border-radius: 2px;
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr min-content 1fr;

    & > div:first-of-type {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        button {
            align-self: flex-end;
        }
    }

    & > div:last-of-type {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
`;

export default function Property(props) {
    const { disabled, onChange, parameterID, properties } = props;

    const parameterQuery = useSuspenseParameter(parameterID);
    const { parameter } = parameterQuery.data;

    return (
        <Styled data-n-properties={ properties.length }>
            <div>
                <ParameterCardContainer
                    id={ parameterID }
                />
            </div>
            <div>
                <UI.Button
                    $appearance="subtle"
                    disabled={ disabled }
                    onClick={ () => onChange(undefined, { parameter: { id: parameterID }, __id: crypto.randomUUID(), value: undefined, unit: parameter.units?.[0] }) }
                >
                    Add value
                </UI.Button>
            </div>
            <div>
                {
                    properties.map(
                        (prop) => (
                            <ValueInput
                                key={ prop.__id }
                                disabled={ disabled }
                                onChange={ onChange }
                                parameterID={ parameterID }
                                properties={ [prop] }
                                value={ prop.value }
                                unit={ prop.unit }
                            />
                        )
                    )
                }
            </div>
        </Styled>
    );
}

